module.exports = {
  commandStack: [ 'type', require(79) ]
};
